import React, { useEffect, useState } from "react";
import {
  useSearchParams
} from "react-router-dom";
import { Link } from "react-router-dom";
import s from './cards.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import CreateCard from '../components/CreateCard';
import ItemMainModal from '../components/Modal/ItemMainModal';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import {Form, InputGroup} from 'react-bootstrap';
import { ReactComponent as SearchSolid} from '../asset/search-solid.svg';
import starPng from'../asset/star.png';
import starDarkPng from'../asset/star-dark.png';
import cardGamesPng from'../asset/card-games.png';
import editGreenPng from'../asset/edit-green.png';
import refreshPng from'../asset/refresh.png';
import book from'../asset/book.png';
import {Image} from 'react-bootstrap';
import {setGeneralStorage, getGeneralStorage} from '../middleware/dataStorage';


export default function Cards() {
	const navigate = useNavigate();
	let [searchParams, setSearchParams] = useSearchParams();
	
	let defaultToggle = JSON.parse(getGeneralStorage('cardPanelToggle')) ?? {"Seeding" : true,"Budding" : true,"Blossom" : true,"Explorer" : true,"Voyager" : true,"Navigator" : true,"Trailblazer" : true};
	
	const [toggleLevelStatus, setToggleLevelStatus] = useState(defaultToggle);
	
	const [toggleCreate, setToggleCreate] = useState(false);
	const [toggleCreateCard, setToggleCreateCard] = useState(false);
	
	const [cards, setCards] = useState({
		"Seeding" : [],
		"Budding" : [],
		"Blossom" : [],
		"Explorer" : [],
		"Voyager" : [],
		"Navigator" : [],
		"Trailblazer" : []
	});
	const [statistic, setStatistic] = useState({
		"Seeding" : "-",
		"Budding" : "-",
		"Blossom" : "-",
		"Explorer" : "-",
		"Voyager" : "-",
		"Navigator" : "-",
		"Trailblazer" : "-"
	});
	
	const fetchData = () => {	
		getData('item/listCards', navigate)
			.then(res => {
				let data = res.data;
				
				setCItem(data[0]);
				let levelMap = {
					"Seeding" : [],
					"Budding" : [],
					"Blossom" : [],
					"Explorer" : [],
					"Voyager" : [],
					"Navigator" : [],
					"Trailblazer" : []
				};
				
				data.forEach((v)=>{
					levelMap[v.level].push(v);
				})
				setCards(levelMap);
				setStatistic({
					"Seeding" : (levelMap['Seeding']).length,
					"Budding" : (levelMap['Budding']).length,
					"Blossom" : (levelMap['Blossom']).length,
					"Explorer" : (levelMap['Explorer']).length,
					"Voyager" : (levelMap['Voyager']).length,
					"Navigator" : (levelMap['Navigator']).length,
					"Trailblazer" : (levelMap['Trailblazer']).length,
				});
			}
		);
	}
	
	useEffect(() => {
		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	const ItemTypeIcon = (itemType) => {
		switch(itemType) {
			default :
				return (
				<Image className={s.iconSmall} fluid
					src={book} rounded />	);
		}
	}
	
	const publishItem = (level, itemId, indexD) => {	
		
		let tmpCards = cards[level];
		
		tmpCards[indexD].isPublished = !tmpCards[indexD].isPublished;
		
		
		let obj = {
			'itemId' : itemId,
			'isPublished' : tmpCards[indexD].isPublished,
		}
		postData("item/publish", obj, navigate); 
		
		
		
		setCards({...cards, [level]:tmpCards});		
	}
	
	const [mShow, setMShow] = useState(false);
	const [cItem, setCItem] = useState();
	const [cRawItem, setCRawItem] = useState();
	const getCardByItemId = (itemId, item) => {
		getData('item/getByItemId?itemId=' + itemId, navigate)
			.then(res => {	
				setCItem(res.data);
				setCRawItem(JSON.parse(JSON.stringify(res.data)));
			}
		);
		setMShow(true);	
	}
	
	
	const triggertoggleLevelStatus = (name) => {
		let tmp = {...toggleLevelStatus};
		tmp[name] = !tmp[name];
		setToggleLevelStatus(tmp);
		setGeneralStorage('cardPanelToggle', JSON.stringify(tmp));
	}
	
	const CardSet = (props) => {
		let name = props.name;
		let data = props.data;
		return (<div>
			<div className={s.setDescription}>
				<div className={s.toggleIcon} onClick={()=>triggertoggleLevelStatus(name)}>{(toggleLevelStatus[name]) ? "-":"+" }</div>
				<div> {name} </div>
				<div> Total:{data.length} </div>
			</div>
			
				<div className={[s.cardHolder, (toggleLevelStatus[name]) ? s.cardHolderShow : s.cardHolderHide].join(' ')}>
					{data.map((v, indexV)=>(
						<div key={v.itemId} className={s.cardOuterHolder}>
							
							<div className={(v.isPublished == 1) ? s.card : s.cardUnpublished}>
								<div className={s.cardImageHolder}>
									<img className={s.cardImg} src={v.imgPath} alt="icon"/>
										{ (v.isPublished == 1) && (<img onClick={()=>publishItem(name, v.itemId, indexV)} className={s.starIcon} src={starPng} alt="icon"/>)}
										{ (v.isPublished != 1) && (<img onClick={()=>publishItem(name, v.itemId, indexV)} className={s.starDarkIcon} src={starDarkPng} alt="icon"/>)}
									<img onClick={()=>getCardByItemId(v.itemId, v)} className={s.editGreenIcon} src={editGreenPng} alt="icon"/>
								</div>
								<div className={(v.isPublished != 1) ? s.cardNameHolderBlock : s.cardNameHolder}>{v.name}</div>
								<div className={s.cardSentenceHolder}>{(v.name.endsWith("...") || v.name == v.sentence) ? "" : v.sentence}</div>
								<div className={(v.isPublished != 1) ? s.cardItemIdBlock : s.cardItemId}>{v.itemId}</div>
							</div>
							{ (v.isPublished != 1) && (<div className={s.cardBlockOverlay}></div>)}
						</div>))
					}
				</div>
			
		</div>);
	}
	
	
	return (
		<div>
			<ItemMainModal rawItem={cRawItem} item={cItem} setItem={setCItem} show={mShow} setShow={setMShow}/>
			<div className={s.inputHolder}>
				<div>
					<ul>
						<li>
							<span>Seeding: {statistic.Seeding}</span>
							<span>Budding: {statistic.Budding}</span>
							<span>Blossom: {statistic.Blossom}</span>
							<span>Explorer: {statistic.Explorer}</span>
							<span>Voyager: {statistic.Voyager}</span>
							<span>Navigator: {statistic.Navigator}</span>
							<span>Trailblazer: {statistic.Trailblazer}</span>
						</li>
					</ul>
				</div>
			
				<div>
					<div>
						<img onClick={()=>fetchData()}className={s.refreshIcon} src={refreshPng} alt="icon"/>
					</div>
					<div className={s.createCardIconHolder} onClick={()=>setToggleCreateCard(!toggleCreateCard)}>
						<img className={s.createCardIcon} src={cardGamesPng} alt="icon"/>
						<div className={s.createCardAddIcon}>+</div>
					</div>
				</div>
			</div>
						
			{
				(toggleCreateCard) && (<div>
					<CreateCard />
				</div>)
			}
			
			<div>
			{<CardSet name='Seeding' data={cards.Seeding}/>}
			{<CardSet name='Budding' data={cards.Budding}/>}
			{<CardSet name='Blossom' data={cards.Blossom}/>}
			{<CardSet name='Explorer' data={cards.Explorer}/>}
			{<CardSet name='Voyager' data={cards.Voyager}/>}
			{<CardSet name='Navigator' data={cards.Navigator}/>}
			{<CardSet name='Trailblazer' data={cards.Trailblazer}/>}
			</div>
		</div>
  );
}